export const SearchProfiles = {
	FIND_PRODUCT_BY_SEARCH_TERM_WITH_PRICE: 'HCL_V2_findProductsBySearchTermWithPrice',
	FIND_PRODUCT_BY_CATEGORY_WITH_PRICE_RANGE:
		'HCL_V2_findProductsByCategoryWithPriceRangeSequenceTest',
	HDM_FIND_PRODUCT_BY_PART_NUMBER_DETAILS: 'HCL_V2_findProductByPartNumber_Details',
	HDM_FIND_PRODUCT_BY_IDS_DETAILS: 'HDM_V2_findProductByIds_IncludeZeroPrices',
	HDM_FIND_PRODUCTS_BY_PART_NUMBER_EMARSYS_CAROUSEL: 'HDM_findProductsByPartNumberEmarsysCarousel',
	HDM_FIND_PRODUCTS_CART_LITE: 'HDM_findProductsCartLite',
	HDM_FIND_PRODUCTS_CART_LITE_BY_SKU: 'HDM_findProductsCartLiteBySku',
};
